<template>
  <div>
    <el-dialog title="新增地址" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
      <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="140px">
        <el-form-item label="收货人：" prop="customerName">
          <el-input v-model="form.customerName" placeholder="请输入收货人姓名" />
        </el-form-item>
        <el-form-item label="收货人手机号：" prop="customerPhone">
          <el-input v-model="form.customerPhone" placeholder="请输入收货人手机号" maxlength="11" />
        </el-form-item>
        <el-form-item label="收货地址：" prop="addressArray">
          <el-cascader ref="cascader" @change="changeCascader" :props="cascaderProps" collapse-tags v-model="form.addressArray" :options="regionOptions" clearable></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址：" prop="detailedAddress">
          <el-input v-model="form.detailedAddress" placeholder="请输入详细地址" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button type="primary" @click="doCreate()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import ImageUpload from "@/components/ImageUpload";
import goodsOrderApi from '@/api/order/goodsOrder'
function initFormBean() {
  const formBean = {
    customerName: null,
    customerPhone: null,
    detailedAddress: null,
    userId: null,
    country: '中国大陆',
    province: null,
    city: null,
    district: null,
    provinceCode: null,
    cityCode: null,
    districtCode: null
  }
  return formBean
}

export default {
  components: { ImageUpload },
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        customerName: [{ required: true, message: '请输入收货人姓名', trigger: 'blur' }],
        customerPhone: [{ required: true, message: '请输入收货人手机号', trigger: 'blur' }],
        addressArray: [{ required: true, message: '请选择收货地址', trigger: 'blur' }],
        detailedAddress: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
      },
      isRepSub: false,
      cascaderProps: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child',
      },
      regionOptions: [],
      cId: ''
    }
  },
  created() {
    let regionOptions = JSON.parse(localStorage.getItem('addressTree')) || [];
    this.regionOptions = this.formatCascaderData(regionOptions)
  },
  methods: {
    changeCascader() {
      let { addressArray } = this.form;
      // 获取级联选择器选中项的完整节点信息
      const selectedNodes = this.$refs.cascader.getCheckedNodes()[0];

      this.form.provinceCode = addressArray[0];
      this.form.cityCode = addressArray[1];
      this.form.districtCode = addressArray[2];

      // 添加省市区中文名称
      this.form.province = selectedNodes.parent.parent.label ;
      this.form.city = selectedNodes.parent.label;
      this.form.district = selectedNodes.label;
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    handleShow(row) {
      this.resetForm()
      this.form.userId = row.userId;
      this.cId = row.id
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          let params = {
            ...this.form
          }
          delete params.addressArray
          goodsOrderApi.addUserAddr(params).then((data) => {
            this.postCallback(data)
          }).catch(res => {
            this.isRepSub = false
          });
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created', this.cId)
    },
  }
}
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}

::v-deep .el-select {
  width: 100%;
}

::v-deep .el-cascader {
  width: 100%;
}
</style>
